// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"27":"87376f65c6bf441d","29":"eea06496b8469f61","939":"1eb0e7ff48d63d83"}[chunkId] + ".js";
};